import { useStore } from "@/stores/useStore";
import { useCallback, useMemo, useState } from "react";
import { Container } from "@/types/v2";
import { checkContainerConfiguration } from "@/lib/checkContainerConfiguration";

export const useContainerConfigurationCheck = (containerId: string) => {
  const { shop } = useStore();
  const containers = useMemo(() => shop?.containers ?? [], [shop]);
  const thisContainer = useMemo(
    () => containers.find((c) => c.id === containerId),
    [containers, containerId]
  );

  const [valid, setValid] = useState(true);
  const [message, setMessage] = useState<string | null>(null);

  const runCheck = useCallback(
    ({
      linkedTechnicianId,
      linkedSourceLabel,
      bidirectionalLabel,
    }: {
      linkedTechnicianId: Container["linkedTechnicianId"];
      linkedSourceLabel: Container["linkedSourceLabel"];
      bidirectionalLabel?: Container["bidirectionalLabel"];
    }) => {
      if (!thisContainer) {
        setValid(true);
        setMessage(null);
        return;
      }
      const result = checkContainerConfiguration(
        {
          ...thisContainer,
          linkedTechnicianId,
          linkedSourceLabel,
          bidirectionalLabel,
        },
        containers
      );
      setValid(result.valid);
      if (!result.valid) {
        setMessage(result.message);
      } else {
        setMessage(null);
      }
    },
    [containers, thisContainer]
  );

  return { runCheck, valid, message, thisContainer };
};
